var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#2B63D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C26.4351 48 28.7854 47.6374 31 46.9631V33.4999L42.5234 39.2616C44.0424 37.4201 45.2921 35.3481 46.2122 33.106L42.0002 31H46.9631C47.6374 28.7854 48 26.4351 48 24C48 21.5649 47.6374 19.2146 46.9631 17H41.9999L46.2122 14.8938C45.4095 12.9378 44.3559 11.1113 43.0915 9.45423L31 15.5V1.03687C28.7854 0.362645 26.4351 0 24 0C21.5649 0 19.2146 0.362645 17 1.03687V14.4999L5.47671 8.73828C3.95769 10.5798 2.70797 12.6518 1.78784 14.8938L6.00015 17H1.03687C0.362645 19.2146 0 21.5649 0 24C0 26.4351 0.362645 28.7854 1.03687 31H5.99994L1.78784 33.106C2.59058 35.0621 3.64418 36.8886 4.90861 38.5457L17 32.5V46.9631C19.2146 47.6374 21.5649 48 24 48Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37172 37.8142L17 31.5V31H14L3.3901 36.305C3.6988 36.8209 4.02632 37.3243 4.37172 37.8142zM2.14331 14.0717L7.99991 17H11.9999L2.94454 12.4723C2.65834 12.994 2.39096 13.5274 2.14331 14.0717zM45.8565 33.9283C45.6089 34.4726 45.3415 35.0061 45.0553 35.5277L35.9999 31H39.9999L45.8565 33.9283zM44.6097 11.6951L33.9999 17H30.9999V16.5L43.6281 10.1859C43.9735 10.6758 44.301 11.1792 44.6097 11.6951z",
    fill: "#E62048"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 47.6682C26.6992 47.8864 25.3628 48 24 48C22.6372 48 21.3008 47.8864 20 47.6682V28H0.331834C0.113595 26.6992 0 25.3628 0 24C0 22.6372 0.113595 21.3008 0.331834 20H20V0.331834C21.3008 0.113595 22.6372 0 24 0C25.3628 0 26.6992 0.113595 28 0.331834V20H47.6682C47.8864 21.3008 48 22.6372 48 24C48 25.3628 47.8864 26.6992 47.6682 28H28V47.6682Z",
    fill: "#E62048"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5C36.9787 0.5 47.5 11.0213 47.5 24Z",
    stroke: "#000",
    strokeOpacity: 0.1
  })));
}

export default SvgUk;